import {
  GET_COURSE_TYPE_FAILURE,
  GET_COURSE_TYPE_REQUEST,
  GET_COURSE_TYPE_SUCCESS,
  GET_HEAR_ABOUT_US_FAILURE,
  GET_HEAR_ABOUT_US_REQUEST,
  GET_HEAR_ABOUT_US_SUCCESS,
  GET_INTERESTS_FAILURE,
  GET_INTERESTS_REQUEST,
  GET_INTERESTS_SUCCESS,
} from "./ActionType";

const initialState = {
  interests: null,
  hearAboutUs: null,
  courseTypes: null,
  isLoading: false,
  error: null,
};

export const enumReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_HEAR_ABOUT_US_REQUEST:
    case GET_INTERESTS_REQUEST:
    case GET_COURSE_TYPE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case GET_HEAR_ABOUT_US_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        hearAboutUs: action.payload,
      };
    case GET_INTERESTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        interests: action.payload,
      };
    case GET_COURSE_TYPE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        courseTypes: action.payload,
      };

    case GET_HEAR_ABOUT_US_FAILURE:
    case GET_INTERESTS_FAILURE:
    case GET_COURSE_TYPE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
